import React, { useContext, useEffect, useState } from 'react';
import Footer from './../Footer';
import axios from 'axios';
import { site_url, site_url_img } from "./../config.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import { Link } from "react-router-dom";
import { AuthContext } from './../AuthContext';
import { parseStoredAccessToken } from '../parseStoredAccessToken.js';
import { FormatDate } from '../Function';
import { FaSearch, FaAngleDoubleRight, FaArrowLeft, FaHeart, FaAngleRight, FaMapMarkerAlt, FaHome, FaList } from "react-icons/fa";

import { Container, Row, Col, Button, Form, Card, Carousel, Navbar, Nav } from "react-bootstrap";


function Index({ children }) {

  const { user, fulluser } = useContext(AuthContext);

  const [UserActivity, setUserActivity] = useState([]);
  const getUserdetails = async () => {
    const token = parseStoredAccessToken(user);
    if (token) {
      axios.get(site_url + "/customer_bills", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
        .then(res => {
          if (res.data.status == 'success') {
            setUserActivity(res.data.billlist);
          } else {

          }
        })
        .catch(err => {
          console.error("API Error:", err.response.data);
        });
    }
  };

  useEffect(() => {
    getUserdetails();
  }, [user]);

  const goBack = () => {
    window.history.back(); // Goes back to the previous page
  };

  return (
    <div>
      <Navbar expand="lg" className="navbar px-3">

        <Navbar.Brand className="fw-bold text-white"><center><FaArrowLeft onClick={goBack} className="fs-5 text-white notificaton-icon" /> Purchase Bills</center></Navbar.Brand>
        <Nav className="ms-auto d-flex align-items-center">
        </Nav>
      </Navbar>

      <div className="transactions p-3" style={{ marginBottom: '30%' }}>

        {UserActivity?.map((shop, index) => (

          <Link to={`/Billdetails`} className="item" state={{ shop }}>
            <div className="detail">
              <img
                src="assets/img/sample/brand/order.png"
                alt="img"
                className="image-block imaged w48"
              />
              <div>
                <strong>Order Id:{shop.id} (Token: <span className="text-danger">{shop.token_no}</span>)</strong>
                <span>{FormatDate(shop.date_time || shop.created_at)}</span>
                <p><span className='text-danger'><b>{shop.paytype}</b></span> / <span className='badge badge-success'>Paid</span></p>
              </div>
            </div>
            <div className="right">
              <div className="price text-danger"> Reward Points:{shop.billamount}</div>
            </div>
          </Link>
        ))}

      </div>
    </div>
  )
}

export default Index